import { LotInfo } from '~/models'
import { $axios } from '~/utils/api'
const END_POINT = '/map'

const getConsumerMapProperty = (
    slug: string,
    id: number | string
    ): Promise<LotInfo> => {
        const request = `${END_POINT}/consumer/properties/${id}?project=${slug}`

        return $axios.$get(request)
    }

export {
    getConsumerMapProperty
}